/*******************************************************************************
TRIGGER GET CUSTOM LIST CONTENT
Trigger appending more custom list content to the page.
*******************************************************************************/

import showErrorNotificationBar from '../../universal/error-handling/show-error-notification-bar';

export default async function getCustomListContent(listID, listType, lastContent, excludedContentIDs, style) {
    try {
        const response = await $.ajax({
            type   : 'GET',
            url    : '/frontend/ajax/get-custom-list-content.php',
            data   : { listID, listType, lastContent, excludedContentIDs, style },
            timeout: 20000,
        });

        // Check for errors with the data
        if (response.error || !response.success) { throw new Error(response.error); }

        // Return the data
        return {
            contentHTML    : response.contentHTML,
            newLastContent : response.newLastContent,
            haveMoreContent: response.haveMoreContent,
        };
    }
    catch (error) {
        showErrorNotificationBar('We were unable to retrieve more content for you. Please try again.', 3000);
    }
}
